import React, { useEffect, useState } from 'react'
import { IArticleHead } from '../../../interfaces/article'
import Modal from '../../modal/modal.component'
import HomePagePopupContent from './homePagePopupContent.component'

const HOME_POPUP_ID = 'home-popup-id'

interface IHomePagePopupWrapperProps {
  data: IArticleHead
}

const HomePagePopupWrapper: React.FC<IHomePagePopupWrapperProps> = ({
  data,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleClose = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    if (data) {
      const popupId = sessionStorage.getItem(HOME_POPUP_ID)

      if (popupId !== data.slug) {
        sessionStorage.setItem(HOME_POPUP_ID, data.slug)
        setIsOpen(true)
      }
    }
  }, [data])

  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <HomePagePopupContent data={data} />
    </Modal>
  )
}

export default HomePagePopupWrapper
